import React from 'react';

const Team = () => {
  const teamMembers = [
    {
      id: 1,
      name: 'Shivanshu Singh',
      role: 'Co-founder',
      description: 'Visionary leader driving innovation and strategic growth'
    },
    {
      id: 2,
      name: 'Vikas Upadhyay',
      role: 'Co-founder',
      description: 'Passionate entrepreneur focused on business development and partnerships'
    },
    {
      id: 3,
      name: 'Ritika Soni',
      role: 'Digital Marketing Manager',
      description: 'Expert in digital strategies and brand growth'
    },
    {
      id: 4,
      name: 'Sarika Gangwar',
      role: 'Lead Developer',
      description: 'Full stack developer who built and maintains the platform'
    }
  ];

  return (
    <section className="bg-white py-16 md:py-24 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              className="text-gray-400"
            >
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
            <span className="text-sm md:text-base text-gray-500 uppercase tracking-wide font-medium">
              OUR TEAM
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 uppercase mb-4">
            Meet Our Expert Team
          </h2>
          <div className="w-16 h-0.5 bg-gray-900 mx-auto mb-6"></div>
          <p className="text-base md:text-lg text-gray-700 max-w-2xl mx-auto">
            Our dedicated professionals are committed to delivering exceptional property management services
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {teamMembers.map((member) => (
            <div
              key={member.id}
              className="bg-gray-50 rounded-lg p-6 md:p-8 text-center hover:shadow-lg transition-shadow"
            >
              <div className="w-32 h-32 mx-auto mb-6 rounded-full bg-gradient-to-br from-furniflex-teal to-teal-600 flex items-center justify-center">
                <span className="text-4xl font-bold text-white">
                  {member.name.split(' ').map(n => n[0]).join('')}
                </span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                {member.name}
              </h3>
              <p className="text-furniflex-teal font-semibold mb-3 text-sm uppercase tracking-wide">
                {member.role}
              </p>
              <p className="text-sm text-gray-600 leading-relaxed">
                {member.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;

